var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('b-button',{attrs:{"size":"sm","variant":"primary","to":{ name: 'vehicle_status_history' },"aria-label":"VSM History"}},[_c('i',{staticClass:"fa fa-history"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }